import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomButton from "shared/components/common/customButton";
import {
  CreateUpdatePolicyService,
  GetSinglePolicyService,
} from "shared/services/policies";
import CustomTextEditor from "shared/components/common/customTextEditor";
import { toastMessage } from "shared/components/common/toast";

const CookiesPolicy = () => {
  const [cookies, setCookies] = useState<[] | any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const validationSchema = Yup.object({
    content: Yup.string().required("Content is required"),
  });

  const formik = useFormik({
    initialValues: {
      content: cookies.content,
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        if (formik.values.content !== cookies) {
          setLoading(true);
          setCookies(cookies || formik.values.content);
          await CreateUpdatePolicyService(2, values.content);
          toastMessage("success", "Policy saved successfully!");
        }
      } catch (error) {
        toastMessage("error", "Failed to save policy.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleGetCookies = async () => {
    try {
      const response = await GetSinglePolicyService(2);
      const cookiesData = response.data.data;
      setCookies(cookiesData);
    } catch (error) {
      console.error("Error fetching Cookies:", error);
    }
  };

  useEffect(() => {
    handleGetCookies();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <h1 className="font-medium">Cookies Policy</h1>
      <form onSubmit={formik.handleSubmit}>
        <div className="my-4">
          <CustomTextEditor
            value={formik.values.content || cookies}
            onChange={(value) => formik.setFieldValue("content", value)}
            placeholder=""
          />
          {formik.touched.content &&
            formik.values.content &&
            formik.errors.content && (
              // @ts-ignore
              <div className="error">{formik.errors.content}</div>
            )}
        </div>

        <div className="flex justify-end">
          <CustomButton
            title="Create/ Update"
            loading={loading}
            type="submit"
          />
        </div>
      </form>
    </div>
  );
};

export default CookiesPolicy;
